module.exports = __webpack_public_path__ + "static/media/AvenirNext-DemiBold.f8785265.woff2";